import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListTrademark = createAsyncThunk(
  "trademark/getListTrademark",
  async ({ currentPage, pageSize, mcouponBranchId }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/trademarks?has_paginate&size=${pageSize}&page=${currentPage}`;
      if (mcouponBranchId) {
          apiUrl += `&mcoupon_branch_id=${mcouponBranchId}`;
      }
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const createTrademark = createAsyncThunk(
  "trademark/createTrademark",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/trademarks`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateTrademark = createAsyncThunk(
  "trademark/updateTrademark", // Đổi tên hành động cho phù hợp
  async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
    try {
      const response = await http.put(`/api/v1/serviceconnect/trademarks/${id}`, data); // Gọi API PUT
      return response.data; // Trả về kết quả thành công
    } catch (error) {
      return rejectWithValue(error.response.data); // Trả về lỗi nếu có
    }
  }
);

export const deleteTrademark = createAsyncThunk(
  "trademark/deleteTrademark",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/trademarks/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getByTrademarks = createAsyncThunk(
  "trademark/getByTrademarks",
  async () => {
    try {
      const response = await http.get(`/api/v1/serviceconnect/trademarks/get-trademarks`);
      return response.data;
    } catch (error) {
      throw new Error("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);